'use client';

import type { Image } from 'sanity';
import Link from 'next/link';
import { PortableText } from '@portabletext/react';
import type { PortableTextBlock } from '@portabletext/types';
import type { PortableTextComponents } from '@portabletext/react';
import { Box, Text } from '@chakra-ui/react';
import type { TextProps } from '@chakra-ui/react';

type CustomPortableTextProps = TextProps & {
	value: PortableTextBlock[];
};

const CustomPortableText = ({ value, ...other }: CustomPortableTextProps) => {
	const components: PortableTextComponents = {
		list: ({ children }) => (
			<Box
				as={'li'}
				mt={1}
				pl={2}
				whiteSpace={'pre-line'}
			>
				<Text as={'span'} whiteSpace={'pre-line'}>{children}</Text>
			</Box>
		),
		block: {
			h1:     ({ children }) => <Text as={'h1'} textStyle={'h1'}>{children}</Text>,
			h2:     ({ children }) => <Text as={'h2'} textStyle={'h2'}>{children}</Text>,
			h3:     ({ children }) => <Text as={'h3'} textStyle={'h3'}>{children}</Text>,
			h4:     ({ children }) => <Text as={'h4'} textStyle={'h4'}>{children}</Text>,
			h5:     ({ children }) => <Text as={'h5'} textStyle={'h5'}>{children}</Text>,
			h6:     ({ children }) => <Text as={'h6'} textStyle={'h6'}>{children}</Text>,
			normal: ({ children }) => {
				if (children?.toString() === '') {
					return <br />;
				}

				return (
					<Text display={'block'} textStyle={'p2'} whiteSpace={'preserve'}>
						{children}
					</Text>
				);
			},
		},
		marks: {
			link: ({ children, value }) => {
				return (

					<Link href={value?.href} rel={'noreferrer noopener'}>
						<Text {...other}>
							{children}
						</Text>
					</Link>
				);
			},
		},
		types: {
			image: ({ value }: { value: Image & { alt?: string;
				caption?:                                  string; }; }) => {
				return (
					<div>
						{/* <NextImageBox alt={value.alt} image={value} /> */}
						{value.caption && <div>{value.caption}</div>}
					</div>
				);
			},
		},
	};

	return <PortableText components={components} value={value}  />;
};

export default CustomPortableText;